<div id="row" fxLayout="row" style="width: 100%;">
    <div id="container" fxFlex="100">
        <mat-card fxFlex="100" class="mt-10">
            <mat-card-title>
                <span class="p-10">Intrebarea #{{question.position}} </span>
                <span style="float: right;">
                    <button mat-mini-fab color="warn" (click)="deleteQuestion(question)"> <mat-icon>delete_forever</mat-icon></button>
                </span>
                <br>
            </mat-card-title>
            <mat-card-content>
                <div fxFlex="100" class="p-24">
                    <form [formGroup]="questionForm" style="max-width: 100%!important;">

                        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
                            <mat-form-field appearance="standard" fxFlex="50" class="pr-4">
                                <mat-label>Intrebare</mat-label>
                                <input #questionName matInput formControlName="questionName">
                                <mat-icon matSuffix class="disabled-text">question_answer</mat-icon>
                                <mat-error *ngIf="questionForm.get('questionName').errors?.serverError">{{ questionForm.get('questionName').errors?.serverError }}</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="standard" fxFlex="50" class="pr-4">
                                <mat-label>Tip raspuns</mat-label>
                                <select  [(ngModel)]="selectedAnswerTypeId" matNativeControl name="answerType" formControlName="answerType" (change)="onAnswerTypeChange()">
                                    <option value="" selected></option>
                                    <option *ngFor="let answerType of answersTypeList" [value]="answerType.id">{{answerType.name}}</option>
                                </select>
                                <mat-icon matSuffix class="disabled-text">border_inner</mat-icon>
                            </mat-form-field>

                        </div>

                        <div fxLayout fxLayoutWrap fxLayoutGap="25px"  *ngIf="selectedAnswerType">
                            <mat-form-field appearance="standard" fxFlex="100" class="pr-4" *ngIf="selectedAnswerType.options === null">
                                <mat-label>Raspuns la intrebarea - {{questionName.value}}</mat-label>
                                <input matInput formControlName="value" readonly>
                                <mat-icon matSuffix class="disabled-text">keyboard</mat-icon>
                            </mat-form-field>

                            <div fxFlex="100" style="width: 100%;" *ngIf="selectedAnswerType.options !== null">

                                <mat-form-field appearance="standard" fxFlex="50" class="pr-4" *ngFor="let option of selectedAnswerType.options">
                                    <mat-label>#{{option}} - Scrieti text-ul pentru varianta {{option}}</mat-label>
                                    <input matInput formControlName="{{option}}">
                                    <mat-icon matSuffix class="disabled-text">fact_check</mat-icon>
                                </mat-form-field>

                            </div>
                        </div>
                    </form>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

